import React from 'react'
import styled from 'styled-components'

const StyledButton = styled.button`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  box-shadow: none;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  transition: background 0.2s;
  &:hover {
    background: ${({ theme }) => theme.colors.whiteSmoke};
    cursor: ${({ theme }) => theme.cursor.pointer};
  }
`
const StyledGoldButton = styled.button`
  background: ${({ theme }) => theme.colors.gold};
  border: 1px solid ${({ theme }) => theme.colors.gold};
  padding: 0.5rem 0.75rem;
  border-radius: ${({ theme }) => theme.borderRadius}px;
  height: 100%;
  transition: all 0.2s ease;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 20px;
    fill: ${({ theme }) => theme.colors.white};
  }
  &:hover {
    opacity: 0.8;
    cursor: ${({ theme }) => theme.cursor.pointer};
  }
`

const Button = ({ className, label, onClick, style }) => {
  return (
    <StyledButton className={className} style={style} type="button" onClick={onClick}>
      {label}
    </StyledButton>
  )
}

export const GoldButton = ({ label, onClick, style }) => {
  return (
    <StyledGoldButton style={style} type="button" onClick={onClick}>
      {label}
    </StyledGoldButton>
  )
}

export default Button
